import { Button, Container, Header } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { memberSetAgree } from 'volto-m4-theme-addon/actions/member/member';

const messages = defineMessages({
  agreementMinistryLink: {
    id: 'agreementMinistryLink',
    defaultMessage: 'https://okm.fi/en/copyright',
  },
  agreementAntipiracyLink: {
    id: 'agreementAntipiracyLink',
    defaultMessage: 'https://ttvk.fi/en/front-page',
  },
  agreementKopiraittiLink: {
    id: 'agreementKopiraittiLink',
    defaultMessage: 'http://www.kopiraittila.fi/',
  },
});

const Page = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userSession.token);
  const memberUrl = useSelector((state) => state.memberUrl.member.member_url);
  const intl = useIntl();

  const isAuthenticated = !!token;

  const onAgree = async (ev) => {
    ev.nativeEvent.preventDefault();
    if (!isAuthenticated) return;

    if (memberUrl) {
      dispatch(memberSetAgree(memberUrl, true));
    }
    var cameFrom = new URLSearchParams(location.search).get('came_from');
    history.push(cameFrom ? cameFrom : '/');
  };

  const onDisagree = async (ev) => {
    ev.nativeEvent.preventDefault();
    if (!isAuthenticated) return;

    if (memberUrl) {
      dispatch(memberSetAgree(memberUrl, false));
    }
    history.push('/logout');
  };

  return (
    <Container className="basicinfo-prompt-container">
      <Header as="h1" size="medium">
        <FormattedMessage
          id="agreementTitle"
          defaultMessage="Copyright terms for material used in the Moniviestin"
        />
      </Header>
      <p>
        <FormattedMessage
          id="agreementReadCarefully"
          defaultMessage="Read these terms carefully. Acceptance of these copyright terms is required for Moniviestin users."
        />
      </p>
      <p>
        <FormattedMessage
          id="agreementWhenProducing"
          defaultMessage="When producing educational material or other data on the net it is important to consider copyright. If you use copyright-protected material in online learning you must have permission from the copyright holder. Material of this kind includes, for example, articles, presentations, recordings, photos, tables and audiovisual recordings."
        />
      </p>
      <Header as="h2" size="small">
        <FormattedMessage
          id="agreementWhatIsNotAllowedTitle"
          defaultMessage="What is not allowed?"
        />
      </Header>
      <p>
        <FormattedMessage
          id="agreementWhatIsNotAllowedText"
          defaultMessage="The material in and distributed through Moniviestin must be legal, and must not infringe copyright. In addition, distribution of work protected by copyright via Moniviestin is forbidden. This means, for example, that in the teaching context, using recordings of music performances in Moniviestin video will require permission from the performer and the copyright holder. Viewing restriction (e.g. pathkey protection) does not cancel out the obligations defined in the copyright law."
        />
      </p>
      <Header as="h2" size="small">
        <FormattedMessage
          id="agreementWhatIsAllowedTitle"
          defaultMessage="What is allowed?"
        />
      </Header>
      <p>
        <FormattedMessage
          id="agreementWhatIsAllowedText"
          defaultMessage="You are allowed to disseminate information in your own words taken from scientific publications, or from other work produced by other people. You are also allowed to take citations from a published work, to the extent required by the purpose. Material in the internet (e.g. an article or comic strip) can be linked to the description field below the Moniviestin video, as long as the original source is clearly stated."
        />
      </p>
      <Header as="h2" size="small">
        <FormattedMessage
          id="agreementStudentMaterialTitle"
          defaultMessage="Material produced by students"
        />
      </Header>
      <p>
        <FormattedMessage
          id="agreementStudentMaterialText"
          defaultMessage="The teacher or other educational organizer is allowed to use material produced by a student during the course in which the student participates. Material produced by a student cannot be used after the course, nor in any other course, unless a written agreement is made between the two parties."
        />
      </p>
      <Header as="h2" size="small">
        <FormattedMessage
          id="agreementAdherenceToCopyrightTitle"
          defaultMessage="Adherence to copyright is the responsibility of the materials producer, i.e. the responsibility of the teacher/student!"
        />
      </Header>
      <p>
        <FormattedMessage
          id="agreementAdherenceToCopyrightText"
          defaultMessage="Additional information on copyright can be obtained through the copyright organizations and from the following addresses:"
        />
        <br />-{' '}
        <a href={intl.formatMessage(messages.agreementMinistryLink)}>
          <FormattedMessage
            id="agreementMinistryText"
            defaultMessage="Ministry of Education - Copyright in Finland"
          />
        </a>
        <br />-{' '}
        <a href={intl.formatMessage(messages.agreementAntipiracyLink)}>
          <FormattedMessage
            id="agreementAntipiracyText"
            defaultMessage="Copyright Information & Anti-Piracy Centre In Finland"
          />
        </a>
        <br />-{' '}
        <a href={intl.formatMessage(messages.agreementKopiraittiLink)}>
          <FormattedMessage
            id="agreementKopiraittiText"
            defaultMessage="Kopiraittila (in Finnish)"
          />
        </a>
      </p>
      <p>
        <b>
          <FormattedMessage
            id="agreementMemberFolder"
            defaultMessage="Material that is uploaded in the Members-folder will stay published in Moniviestin for 180 days and after that it will be deleted automatically."
          />
        </b>
      </p>
      <p>
        <FormattedMessage
          id="agreementIAcceptText"
          defaultMessage="I accept the terms of copyright concerning material used in Moniviestin, and I agree to be bound by them."
        />
      </p>
      {memberUrl && isAuthenticated ? (
        <>
          <Button
            style={{ marginTop: '1em' }}
            floated="left"
            type="button"
            onClick={onDisagree}
          >
            <FormattedMessage
              id="agreementDisagreeButton"
              defaultMessage="I disagree"
            />
          </Button>
          <Button
            style={{ marginTop: '1em' }}
            floated="left"
            type="button"
            onClick={onAgree}
          >
            <FormattedMessage
              id="agreementAgreeButton"
              defaultMessage="I agree"
            />
          </Button>
        </>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default Page;
